import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { v4 as uuid } from 'uuid';
import { Checkbox } from '../../../../web/components/Checkbox';
import { ISelectBoxOption, SelectBox } from '../../../../web/components/SelectBox';
import { styleSheet } from './styles';

interface IProps {
	checkboxChecked: boolean;
	checkboxDisabled?: boolean;
	className?: string;
	industryName: string;
	onCheckboxChanged(e: React.ChangeEvent<HTMLInputElement>): void;
	onSelectBoxChanged(selectedOption: ISelectBoxOption<string>): void;
	options: ISelectBoxOption<string>[];
	readOnly?: boolean;
	selectedOption: ISelectBoxOption<string>;
	styles?: StyleDeclarationValue[];
}

export const IndustryCategorySelector = ({
	checkboxChecked,
	checkboxDisabled,
	className,
	industryName,
	onCheckboxChanged,
	onSelectBoxChanged,
	options,
	readOnly,
	selectedOption,
	styles,
}: IProps) => {
	/**
	 * Only show dropdown if there are options
	 */
	return options?.length > 0 ? (
		<div className={`${css(styleSheet.container, ...(styles || []))} industry-category-selector ${className || ''}`}>
			<Checkbox
				checked={checkboxChecked}
				disabled={checkboxDisabled || readOnly}
				id={`industry-checkbox-${uuid()}`}
				onChange={onCheckboxChanged}
				type='large'
			>
				<span className={css(styleSheet.industryName)}>{industryName === '_Others_' ? 'Others' : industryName}</span>
			</Checkbox>
			<div className={css(styleSheet.selectContainer)}>
				<SelectBox
					disabled={readOnly}
					menuClassName={css(styleSheet.selectMenu)}
					onSelectionChanged={onSelectBoxChanged}
					options={options}
					placeholder={<span>Select a category...</span>}
					selectedOption={selectedOption}
					triggerClassName={` ${css(styleSheet.select)}`}
				/>
			</div>
		</div>
	) : (
		<></>
	);
};
